/**
 * Created by JasonChou on 16/5/2.
 */

import Vue from 'vue';

export var dateFormat =function(date, format){
    date = new Date(date);
    var map = {
        "M": date.getMonth() + 1, //月份
        "d": date.getDate(), //日
        "h": date.getHours(), //小时
        "m": date.getMinutes(), //分
        "s": date.getSeconds(), //秒
        "q": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
        var v = map[t];
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v;
                v = v.substr(v.length - 2);
            }
            return v;
        }
        else if (t === 'y') {
            return (date.getFullYear() + '').substr(4 - all.length);
        }
        return all;
    });
    return format;
};


export var timeFormat = function (time, format) {

    time = +time;
    var h, m, s, S;
    S = time % 1000;
    time = Math.floor(time / 1000);
    s = time % 60;
    time = Math.floor(time / 60);
    m = time % 60;
    time = Math.floor(time / 60);
    h = time;

    var map = {
        "h": h, //小时
        "m": m, //分
        "s": s, //秒
        "S": S //毫秒
    };
    format = format.replace(/([hmsS])+/g, function (all, t) {
        var v = map[t];
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v;
                v = v.substr(v.length - 2);
            }
            return v;
        }
        return all;
    });
    return format;
};


Vue.filter('publishTime', function (date) {
  date = new Date(date).getTime();
  var now = Date.now();

  var diff = now - date; //毫秒

  var _10Mins = 10 * 60 * 1000;

  if (diff <= _10Mins) {
    return '刚刚';
  }


  var _60Mins = 60 * 60 * 1000;

  if (diff < _60Mins) {
    return timeFormat(diff, 'm分钟前');
  }


  var _24Hours = 24 * 60 * 60 * 1000;


  if (diff < _24Hours) {
    return timeFormat(diff, 'h小时前');
  }

  return dateFormat(date, 'yy-MM-dd hh:mm');

});


Vue.filter('dateFormat', dateFormat);
Vue.filter('timeFormat', timeFormat);



// WEBPACK FOOTER //
// ./src/filters/dateFormat.js